import React, { useState, useMemo, useEffect } from 'react';
import Proptypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
// import NewIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/InsertDriveFile';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import ScheduleIcon from '@material-ui/icons/Schedule';
import RateReviewIcon from '@material-ui/icons/RateReview';
import AssessmentIcon from '@material-ui/icons/Assessment';
import BallotIcon from '@material-ui/icons/Ballot';
// import ApprovedIcon from '@material-ui/icons/AssignmentTurnedIn';
import PublishedIcon from '@material-ui/icons/ViewList';
// import BookIcon from '@material-ui/icons/Book';
import UnpublishedIcon from '@material-ui/icons/Block';
import ExcludedIcon from '@material-ui/icons/VisibilityOff';
import UpdatesIcon from '@material-ui/icons/Notifications';
import ISubscribeIcon from '@material-ui/icons/AddAlert';
import TextsmsIcon from '@material-ui/icons/Textsms';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import GlobeIcon from '@material-ui/icons/Public';
import NavigationItem from './NavigationItem';
import NavigationHeader from './NavigationHeader';
import { getMarketName, getConfigs } from '../../features/app/selectors';
import { FranchiseType } from '../../constants/franchiseType';

import {
  newIngredientsRoute,
  draftPPIsRoute,
  publishedPPIsRoute,
  newDishesRoute,
  newGlobalDishesRoute,
  draftPPSIsRoute,
  publishedPPSIsRoute,
  approvedPPSIsRoute,
  unpublishedPpsisRoute,
  unpublishedPpisRoute,
  excludedDishesRoute,
  excludedIngredientsRoute,
  globalWaitingReviewRoute,
  updatesRoute,
  approvalStatusPPSIsRoute,
  totalRangeDishStatisticsRoute,
  coWorkerEngagementReportMarketRoute,
  coWorkerEngagementReportListRoute,
  globalSearchRoute,
  uploadFileRoute,
  bomReportNirRoute,
  globalPpsisRoute,
  globalPpsisNirRoute,
  feedbackRoute
  // newUpdatesRoute
} from '../../routes';
import EnvironmentName from '../Internationalize/EnvironmentName';
import { getAppVersion } from '../../utils/version';
import { getIsGlobalUser } from '../../features/loginSystem/selectors';
import SearchIcon from '@material-ui/icons/Search';
import { getEnvironmentType } from 'utils/environment';
import {
  getFeedbackCount,
  getIsFetching
} from 'features/FeedbackContainer/selector';
import { fetchFeedbackCount } from 'features/FeedbackContainer/actions';
import { toJS } from 'utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  toolbar: {
    background: theme.palette.primary.main
  },
  title: {
    color: theme.palette.primary.contrastText
  },
  wrapper: {
    width: 300,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  spacer: {
    flexGrow: 1
  },
  version: theme.mixins.gutters({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }),
  firstLevelItems: {
    backgroundColor: '#fff'
  },
  search: {
    marginLeft: '14px',
    cursor: 'pointer'
  }
}));

const handleClick = (history, toggleNavDrawer) => path => {
  toggleNavDrawer();
  history.push(path);
};

export function AppNavDrawer({ open, toggleNavDrawer }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const isGlobalUser = useSelector(getIsGlobalUser);
  const dispatch = useDispatch();
  const filter = useMemo(() => ({ matchingNotUptoDate: true }), []);
  const ppsiAdmin = JSON.parse(localStorage.getItem('ppsiAdmin'));
  const userMarket = useSelector(getMarketName);
  const franchiseType = useSelector(getConfigs).toJS().franchise;
  const feedbackCountData = useSelector(getFeedbackCount);
  const feedbackCount = toJS(feedbackCountData);
  const numericFeedbackCount = Number(
    feedbackCount && feedbackCount.feedBackCount
      ? feedbackCount.feedBackCount
      : 0
  );
  const isFetching = useSelector(getIsFetching);
  const [openHeaders, setOpenHeaders] = useState({
    new: false,
    ingredientInstructions: false,
    dishInstructions: false,
    other: false,
    updates: false,
    waitingreview: false,
    reports: false,
    configureRange: false
  });

  useEffect(() => {
    if (open) {
      dispatch(fetchFeedbackCount());
    }
  }, [open]);

  const onClickHeader = name => {
    const isHeaderOpen = openHeaders[name];
    setOpenHeaders({ ...openHeaders, [name]: !isHeaderOpen });
  };
  const routeClick = handleClick(history, toggleNavDrawer);

  const filterOnlyServiceOffice = () => !isGlobalUser;
  const filterOnlyGlobalUser = () => isGlobalUser;

  return (
    <Drawer open={open} onClose={toggleNavDrawer}>
      <div className={classes.wrapper}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" className={classes.title} noWrap>
            <EnvironmentName />
          </Typography>
          <SearchIcon
            htmlColor="white"
            fontSize="large"
            className={classes.search}
            onClick={() => {
              const searchParams = new URLSearchParams(location.search);
              routeClick(globalSearchRoute(searchParams.get('search')));
            }}
          />
        </Toolbar>
        <List component="nav">
          <NavigationHeader
            text="Updates"
            open={openHeaders.updates}
            onClick={() => onClickHeader('updates')}
          >
            {/* <List component="div" disablePadding>
              <NavigationItem
                text="Updates"
                Icon={UpdatesIcon}
                onClick={() => routeClick(updatesRoute())}
              />
            </List> */}
            {/* {getEnvironmentType() !== 'prod' && ( */}
            <List component="div" disablePadding>
              <NavigationItem
                text="Updates"
                Icon={UpdatesIcon}
                onClick={() => routeClick(updatesRoute())}
              />
            </List>
            {/* )} */}
          </NavigationHeader>
          <NavigationHeader
            text="Waiting for Review"
            open={openHeaders.waitingreview}
            onClick={() => onClickHeader('waitingreview')}
            visible={filterOnlyGlobalUser}
          >
            <List component="div" disablePadding>
              <NavigationItem
                text="Waiting for Review"
                Icon={RateReviewIcon}
                onClick={() => routeClick(globalWaitingReviewRoute())}
                // visible={filterOnlyGlobalUser}
              />
            </List>
          </NavigationHeader>
          <NavigationHeader
            text="Dish Instructions"
            open={openHeaders.dishInstructions}
            onClick={() => onClickHeader('dishInstructions')}
          >
            <List component="div" disablePadding>
              {franchiseType === FranchiseType.INGKA && (
                <NavigationItem
                  text="New Global Dishes"
                  Icon={BallotIcon}
                  onClick={() => routeClick(newGlobalDishesRoute())}
                  visible={filterOnlyServiceOffice}
                />
              )}
              <NavigationItem
                text={isGlobalUser ? 'New Dishes' : 'New Market Dishes'}
                Icon={PublishedIcon}
                onClick={() => routeClick(newDishesRoute())}
              />
              <NavigationItem
                text="Draft"
                Icon={DraftsIcon}
                onClick={() => routeClick(draftPPSIsRoute())}
              />
              <NavigationItem
                text="Approval Status"
                Icon={SwapHorizIcon}
                onClick={() => routeClick(approvalStatusPPSIsRoute())}
                visible={filterOnlyServiceOffice}
              />
              <NavigationItem
                text="Scheduled Publish"
                Icon={ScheduleIcon}
                onClick={() => routeClick(approvedPPSIsRoute())}
              />
              <NavigationItem
                text="Published"
                Icon={PlaylistAddCheckIcon}
                onClick={() => routeClick(publishedPPSIsRoute())}
              />
              <NavigationItem
                text="Unpublished"
                Icon={UnpublishedIcon}
                onClick={() => routeClick(unpublishedPpsisRoute())}
              />
              <NavigationItem
                text="Excluded"
                Icon={ExcludedIcon}
                onClick={() => routeClick(excludedDishesRoute())}
              />
              {franchiseType !== FranchiseType.INGKA && (
                <NavigationItem
                  text="Global PPSI"
                  Icon={GlobeIcon}
                  onClick={() => routeClick(globalPpsisNirRoute(userMarket))}
                />
              )}
            </List>
          </NavigationHeader>
          <NavigationHeader
            text="Ingredient Instructions"
            open={openHeaders.ingredientInstructions}
            onClick={() => onClickHeader('ingredientInstructions')}
          >
            <List component="div" disablePadding>
              <NavigationItem
                text="New Ingredients"
                Icon={PublishedIcon}
                onClick={() => routeClick(newIngredientsRoute())}
              />
              <NavigationItem
                text="Draft"
                Icon={DraftsIcon}
                onClick={() => routeClick(draftPPIsRoute())}
              />
              <NavigationItem
                text="Published"
                Icon={PlaylistAddCheckIcon}
                onClick={() => routeClick(publishedPPIsRoute())}
              />
              <NavigationItem
                text="Unpublished"
                Icon={UnpublishedIcon}
                onClick={() => routeClick(unpublishedPpisRoute())}
              />
              <NavigationItem
                text="Excluded"
                Icon={ExcludedIcon}
                onClick={() => routeClick(excludedIngredientsRoute())}
              />
            </List>
          </NavigationHeader>
          <NavigationHeader
            text="Reports"
            open={openHeaders.reports}
            onClick={() => onClickHeader('reports')}
          >
            <NavigationItem
              text="Total Range Dish Statistics"
              Icon={AssessmentIcon}
              onClick={() => routeClick(totalRangeDishStatisticsRoute())}
            />
            {isGlobalUser ? (
              <NavigationItem
                text="Co-Workers Engagement Report"
                Icon={AssessmentIcon}
                onClick={() => routeClick(coWorkerEngagementReportListRoute())}
              />
            ) : (
              <NavigationItem
                text="Co-Workers Engagement Report"
                Icon={AssessmentIcon}
                onClick={() =>
                  routeClick(coWorkerEngagementReportMarketRoute())
                }
              />
            )}
          </NavigationHeader>

          {/* {ppsiAdmin && (
            <NavigationHeader
              text="Configuration"
              open={openHeaders.configuration}
              onClick={() => onClickHeader('configuration')}
            >
              <NavigationItem
                text="Upload"
                Icon={CloudUpload}
                onClick={() => routeClick(uploadFileRoute())}
              />
            </NavigationHeader>
          )} */}
          {franchiseType !== FranchiseType.INGKA && (
            <NavigationHeader
              text="Configure Range"
              open={openHeaders.configureRange}
              onClick={() => onClickHeader('configureRange')}
            >
              <NavigationItem
                text="Upload BOM Report"
                Icon={CloudUpload}
                onClick={() => routeClick(bomReportNirRoute(userMarket))}
              />
            </NavigationHeader>
          )}
        </List>
        <div className={classes.spacer} />
        <List component="NavBottom">
          {!isGlobalUser && (
            <NavigationItem
              text="Feedback"
              Icon={TextsmsIcon}
              onClick={() => routeClick(feedbackRoute())}
              removePaddingBottom={true}
              isShowBadg={true}
              feedbackCount={numericFeedbackCount}
              isFetching={isFetching}
            />
          )}
          {/* <List component="navbottom" style={{paddingTop:"0px"}}>
          <NavigationItem
            text="Sign up for information"
            Icon={ISubscribeIcon}
            onClick={() => window.open('https://isubscribe.ikea.net')}
          />
        </List> */}

          <NavigationItem
            text="Create a Change Request"
            Icon={ISubscribeIcon}
            onClick={() =>
              window.open(
                'https://inter-ikea.atlassian.net/servicedesk/customer/portal/48/group/63/create/291'
              )
            }
          />
        </List>
        <Divider />
        <div className={classes.version}>
          <Tooltip
            title={`Data API URL: ${process.env.REACT_APP_DATA_API_URL}`}
          >
            <Typography variant="caption" align="center">
              <FormattedMessage
                id="appNavDrawer.appVersion"
                values={{
                  version: <code>{getAppVersion()}</code>
                }}
              />
            </Typography>
          </Tooltip>
        </div>
      </div>
    </Drawer>
  );
}

AppNavDrawer.propTypes = {
  toggleNavDrawer: Proptypes.func.isRequired,
  open: Proptypes.bool.isRequired
};

export default AppNavDrawer;
